import { PALETTE, FONT_MONO } from "@/components/cobrain/tokens";

/* Names the sequence that follows the CTA. The biggest reason a warm
   visitor doesn't press "Talk to Us Now" is not knowing what it triggers. */

const BEATS = [
  { n: "01", t: "You answer", b: "Name and number. We call you back, usually within minutes." },
  { n: "02", t: "15 minutes with an engineer", b: "Not a qualifier, not a deck. We look at how the work moves." },
  { n: "03", t: "A written outline", b: "The fixes, in the order they pay back. Yours to keep." },
];

export function AfterClick({ tone = "light", compact = false }: { tone?: "light" | "dark"; compact?: boolean }) {
  const dark = tone === "dark";
  const line = dark ? "rgba(255,255,255,0.14)" : PALETTE.line;
  const head = dark ? "#fff" : PALETTE.ink;
  const body = dark ? "rgba(255,255,255,0.68)" : PALETTE.ink2;

  if (compact) {
    return (
      <details className="svc-after-c" style={{ marginTop: 20 }}>
        <summary style={{
          cursor: "pointer", listStyle: "none", display: "inline-flex", alignItems: "center", gap: 8,
          fontSize: 13.5, color: body, lineHeight: 1.4,
        }}>
          <span style={{
            fontFamily: FONT_MONO, fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase",
            color: PALETTE.amber, fontWeight: 700,
          }}>
            After you click
          </span>
          <span>You answer → 15 min with an engineer → a written outline</span>
        </summary>
        <ul style={{ listStyle: "none", margin: "12px 0 0", padding: 0, display: "grid", gap: 8 }}>
          {BEATS.map((b) => (
            <li key={b.n} style={{ fontSize: 13, lineHeight: 1.5, color: body }}>
              <strong style={{ color: head, fontWeight: 600 }}>{b.t}.</strong> {b.b}
            </li>
          ))}
        </ul>
        <style>{`.svc-after-c > summary::-webkit-details-marker { display: none; }`}</style>
      </details>
    );
  }

  return (
    <div style={{ marginTop: 26 }}>
      <div style={{
        fontFamily: FONT_MONO, fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase",
        color: dark ? PALETTE.amberSoft : PALETTE.muted, fontWeight: 700, marginBottom: 12,
      }}>
        What happens after you click
      </div>
      <ol className="svc-after" style={{
        listStyle: "none", margin: 0, padding: 0,
        display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 0,
        borderTop: `1px solid ${line}`,
      }}>
        {BEATS.map((b, i) => (
          <li key={b.n} style={{
            padding: "14px 16px 14px 0",
            borderLeft: i === 0 ? "none" : `1px solid ${line}`,
            paddingLeft: i === 0 ? 0 : 16,
          }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 5 }}>
              <span style={{ fontFamily: FONT_MONO, fontSize: 10, color: PALETTE.amber, fontWeight: 700 }}>{b.n}</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: head, lineHeight: 1.25 }}>{b.t}</span>
            </div>
            <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: body }}>{b.b}</p>
          </li>
        ))}
      </ol>
      <style>{`
        @media (max-width: 720px) {
          .svc-after { grid-template-columns: 1fr !important; }
          .svc-after > li { border-left: none !important; padding-left: 0 !important;
            border-bottom: 1px solid rgba(0,0,0,0.08); }
          .svc-after > li:last-child { border-bottom: none; }
        }
      `}</style>
    </div>
  );
}

export default AfterClick;
